import Repository from './Repository'

const resource = 'events'

export default {
  getEvents (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  getEvent (tenantId, eventId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/${eventId}`, { params: params })
  },
  createEvent (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateEvent (tenantId, eventId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${eventId}`, data)
  },
  downloadEventSummary (eventId, params) {
    return Repository.get(`exports/${resource}/${eventId}/results-weekly/pdf`, {
      responseType: 'blob',
      params: params
    })
  }
}
